import {i18n} from '@lingui/core';
import {t} from '@lingui/macro';

import {emojiToDefinition} from '../../../srcCommon/helpers/emoji/emojiTextHelpers';
import {baseEmojiValidationMap} from '../../services/emojis/emojis';
import {PreviewerLinkTypesEnum} from './previewerModel';

export function getPreviewerEmojiDefinition(linkType: PreviewerLinkTypesEnum) {
  const highlightEmoji = previewerLinkTypeEmojis[linkType];

  return emojiToDefinition(highlightEmoji, baseEmojiValidationMap);
}

const previewerLinkTypeEmojis: Record<PreviewerLinkTypesEnum, string> = {
  [PreviewerLinkTypesEnum.BOOKING]: 'admission_tickets',
  [PreviewerLinkTypesEnum.DOCUMENT]: 'memo',
  [PreviewerLinkTypesEnum.FLIGHT]: 'airplane',
  [PreviewerLinkTypesEnum.ISSUE]: 'ladybug',
  [PreviewerLinkTypesEnum.MORTGAGE]: 'house_with_garden',
  [PreviewerLinkTypesEnum.OPPORTUNITY]: 'handshake',
  [PreviewerLinkTypesEnum.ORDER]: 'package',
  [PreviewerLinkTypesEnum.PERSON]: 'adult',
  [PreviewerLinkTypesEnum.SHIP]: 'ship',
  [PreviewerLinkTypesEnum.SHIPMENT]: 'package',
  [PreviewerLinkTypesEnum.STAY]: 'beach_with_umbrella',
  [PreviewerLinkTypesEnum.TASK]: 'ballot_box_with_check',
};

export function getPreviewerLinkTypeLabel(linkType: PreviewerLinkTypesEnum) {
  return previewerLinkTypeLabels[linkType];
}

const previewerLinkTypeLabels: Record<PreviewerLinkTypesEnum, string> = {
  [PreviewerLinkTypesEnum.BOOKING]: i18n._(t('previewer-link-type-booking')`Booking`),
  [PreviewerLinkTypesEnum.DOCUMENT]: i18n._(t('previewer-link-type-document')`Document`),
  [PreviewerLinkTypesEnum.FLIGHT]: i18n._(t('previewer-link-type-flight')`Flight`),
  [PreviewerLinkTypesEnum.ISSUE]: i18n._(t('previewer-link-type-issue')`Issue`),
  [PreviewerLinkTypesEnum.MORTGAGE]: i18n._(t('previewer-link-type-mortgage')`Mortgage`),
  [PreviewerLinkTypesEnum.OPPORTUNITY]: i18n._(t('previewer-link-type-opportunity')`Opportunity`),
  [PreviewerLinkTypesEnum.ORDER]: i18n._(t('previewer-link-type-order')`Order`),
  [PreviewerLinkTypesEnum.PERSON]: i18n._(t('previewer-link-type-person')`Person`),
  [PreviewerLinkTypesEnum.SHIP]: i18n._(t('previewer-link-type-ship')`Ship`),
  [PreviewerLinkTypesEnum.SHIPMENT]: i18n._(t('previewer-link-type-shipment')`Shipment`),
  [PreviewerLinkTypesEnum.STAY]: i18n._(t('previewer-link-type-stay')`Stay`),
  [PreviewerLinkTypesEnum.TASK]: i18n._(t('previewer-link-type-task')`Task`),
};
